import { render } from "./advanced.vue?vue&type=template&id=67e288ce&scoped=true"
import script from "./advanced.vue?vue&type=script&lang=js"
export * from "./advanced.vue?vue&type=script&lang=js"

import "./advanced.vue?vue&type=style&index=0&id=67e288ce&lang=scss&scoped=true"
import "./advanced.vue?vue&type=style&index=1&id=67e288ce&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e288ce"]])

export default __exports__